module.exports = __webpack_public_path__ + "img/newRetail-upgrade4.c7fc791b.png";